import { isContainerImageRegistry, isHelmChartFeed } from "@octopusdeploy/octopus-server-client";
import type { FeedType } from "@octopusdeploy/octopus-server-client";
import { useMemo } from "react";
import type { RelatedTriggersDependencies } from "./CalloutReferencedPackageFeedTriggerConnections";
import { AvailableFeedTriggerCallout, MultipleRelatedFeedTriggersCallout, SingleRelatedFeedTriggerCallout } from "./RelatedFeedTriggerCallouts";
import { getRelatedFeedTriggersForPrimaryPackage } from "./triggerPackageRelations";
interface CalloutPrimaryPackageFeedTriggerConnectionsProps {
    dependencies: RelatedTriggersDependencies;
    feedType?: FeedType;
    modelDirty: boolean;
}
export function CalloutPrimaryPackageFeedTriggerConnections({ dependencies, feedType, modelDirty }: CalloutPrimaryPackageFeedTriggerConnectionsProps) {
    const { spaceId, projectSlug } = dependencies;
    const relatedTriggers = useMemo(() => getRelatedFeedTriggersForPrimaryPackage(dependencies), [dependencies]);
    if (relatedTriggers.length === 0) {
        const isContainerRegistryOrHelmFeed = feedType && (isContainerImageRegistry(feedType) || isHelmChartFeed(feedType));
        if (isContainerRegistryOrHelmFeed && !modelDirty) {
            return <AvailableFeedTriggerCallout spaceId={spaceId} projectSlug={projectSlug}/>;
        }
        else {
            return <></>;
        }
    }
    const uniqueTriggerCount = [...new Set(relatedTriggers.map((trigger) => trigger.Id))].length;
    if (uniqueTriggerCount === 1) {
        const triggerId = relatedTriggers[0].Id;
        return <SingleRelatedFeedTriggerCallout triggerId={triggerId} text={"This package is connected to an external feed trigger."} spaceId={spaceId} projectSlug={projectSlug}/>;
    }
    else {
        return <MultipleRelatedFeedTriggersCallout text={"This package is connected to external feed triggers."} spaceId={spaceId} projectSlug={projectSlug}/>;
    }
}
